import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'goodsService',
    standalone: false
})
export class GoodsServicePipe implements PipeTransform {

  transform(value: any, ...args: unknown[]): unknown {
    
    try {
      const data = Number(value);
      if(data === 1) {
        return 'Goods';
      }

      if(data === 2) {
        return 'Service';
      }
    } catch (error) {
      console.warn(error);
    }
    
    
    return null;
  }

}


